import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface ElectricalProps {
  data: {
    voltage: string;
    numberOfPhases: string;
    maxPowerInput: string;
    maxCurrent: string;
    frequency: string;
  };
  onChange: (field: string, value: string) => void;
}

const ElectricalSection: React.FC<ElectricalProps> = ({ data, onChange }) => {
  const phaseOptions = ['1', '3'];

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h5">5. Electrical</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2">
            For single-phase heat pumps, specify phase-neutral voltage. For three-phase units, specify phase-phase voltage.
          </Typography>
        </Box>

        <Paper variant="outlined" sx={{ p: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Voltage (at HP)"
                value={data.voltage}
                onChange={(e) => onChange('voltage', e.target.value)}
                fullWidth
                margin="normal"
                className="blue-highlight"
                size="small"
                helperText="[V]"
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth margin="normal" className="blue-highlight">
                <InputLabel id="number-of-phases-label">Number of Phases (at HP)</InputLabel>
                <Select
                  labelId="number-of-phases-label"
                  value={data.numberOfPhases}
                  label="Number of Phases (at HP)"
                  onChange={(e) => onChange('numberOfPhases', e.target.value)}
                  size="small"
                >
                  <MenuItem value="">
                    <em>Select</em>
                  </MenuItem>
                  {phaseOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                label="Max Power Input"
                value={data.maxPowerInput}
                onChange={(e) => onChange('maxPowerInput', e.target.value)}
                fullWidth
                margin="normal"
                className="blue-highlight"
                size="small"
                helperText="[kW]"
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                label="Max Current (at HP, per phase)"
                value={data.maxCurrent}
                onChange={(e) => onChange('maxCurrent', e.target.value)}
                fullWidth
                margin="normal"
                className="blue-highlight"
                size="small"
                helperText="[A]"
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                label="Frequency"
                value={data.frequency}
                onChange={(e) => onChange('frequency', e.target.value)}
                fullWidth
                margin="normal"
                disabled
                size="small"
                helperText="[Hz]"
              />
            </Grid>
          </Grid>
        </Paper>
      </AccordionDetails>
    </Accordion>
  );
};

export default ElectricalSection;